<template>
  <div class="popup-wrapper" @click.self="close">
    <div class="popup-container md">
      <div class="button close">
        <span role="button" class="btn" @click="close">
          <FontawesomeIcon :icon="['fal','times']" size="lg" class="icn" />
        </span>
      </div>
      <div class="popup">
        <div class="popup-title">
          <span class="hdg02">ノート</span>
        </div>
        <div class="popup-content">
          <ul class="popup-content-list">
            <li v-for="(item, index) in group1.list" :key="'note_' + index">
              <a @click.stop="group1.onNoteClicked(item.id)" role="button">
                <span class="title">{{ item.title }}</span>
                <div class="popup-content-list-item-icn">
                  <span v-if="item.user_file_id > 0" class="image" 
                    :style="[item.image && {backgroundImage : 'url(' + item.image + ')'}]"></span>
                  <span v-else class="image no-image">{{item.create_user_name.slice(0, 1)}}</span>
                  <span class="popup-content-list-item-auth" v-if="item.share_classification === 21">閲覧</span>
                  <span class="popup-content-list-item-auth edit" v-else-if="item.share_classification === 22">編集</span>
                </div>
              </a>
            </li>

          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed } from '@vue/composition-api'
import * as logicQASelectNote from '@/logic/common/SelectNoteForList'

export default defineComponent({
  props: {
    type: {
      type: String,
      required: true
    },
    typeId: {
      type: Number,
      required: true
    },
    startLoading: {
      type: Boolean,
      required: true
    }
  },
  setup (props, context) {

    const group1 = logicQASelectNote.getGroup(props, context)

    const state = reactive({
      isOpenHistoryTags: false
    })
    const close = () => {
      context.emit('closeKnowledgeSelectNote')
    }

    return {
      group1,
      state,
      close
    }
  }
})
</script>

<style lang="scss" scoped>
.popup-content {
  padding: 0 0 40px!important;
  ul {
    list-style: none;
    max-height: 408px;
    overflow-y: auto;
    padding: 40px 0;
    li {
      padding: 0 40px;
      a {
        display: flex;
        align-items: center;
        color: $color-link;
        font-size: 1.6rem;
        position: relative;
        padding: 10px 0;
        .title {
          flex: 1 1 auto;
        }
        .image {
          @include profileImage();
        }
      }
    }
  }
  &-list-item {
    &-icn {
      position: relative;
      padding-right: 20px;
    }
    &-auth {
      padding: 3px 4px;
      position: absolute;
      bottom: 0;
      right: 0;
      font-size: 10px;
      border: 1px solid #EEEEEE;
      color: #646464;
      line-height: 1;
      background-color: #EEEEEE;
      border-radius: 2px;
      z-index: 10;
      &.edit {
        background-color: #80889B;
        color: #FFFFFF;
      }
    }
  }
}
</style>
